import { render, staticRenderFns } from "./empty-message.vue?vue&type=template&id=38e0f060"
import script from "./empty-message.vue?vue&type=script&lang=js"
export * from "./empty-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports